import React, { Component, Fragment } from 'react';
import { services } from '@comall-backend-builder/core';
import { Button as AntButton, Table, Input, Spin, message, Form, Modal } from 'antd';
import { FormComponentProps } from 'antd/es/form';
import { errorHandle } from '../../services/error-handle';
import { ShowProductsUploadButton } from '../../components';

interface PrecellOrderStates {
    columns: object[];
    tableData: object[];
    loading: boolean;
    spinning: boolean;
    showUploadModal: boolean;
    order_no: string;
    receiver_name: string;
    pagination: {};
    importTableData: object[];
    importColumns: object[];
    showFailPop: boolean;
    failNum: number;
    successNum: number;
    totalNum: number;
}
interface PrecellOrderProps {
    form: FormComponentProps['form'];
}

class precellOrder extends Component<PrecellOrderProps, PrecellOrderStates> {
    constructor(props) {
        super(props);
        this.loadProductList = this.loadProductList.bind(this);
        this.clear = this.clear.bind(this);
        this.showModal = this.showModal.bind(this);
        this.downloadMould = this.downloadMould.bind(this);
        this.closeFailPop = this.closeFailPop.bind(this);
        this.search = this.search.bind(this);
    }
    state = {
        spinning: false,
        order_no: '',
        pagination: {
            current: 1,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: false,
            pageSizeOptions: ['10', '15', '20'],
            total: 0,
            onShowSizeChange: this.onShowSizeChange.bind(this),
            onChange: this.onChange.bind(this),
        },
        receiver_name: '',
        columns: [
            {
                title: '订单类型',
                dataIndex: 'orderTypeName',
                key: 'orderTypeName',
            },
            {
                title: '订单编号',
                dataIndex: 'orderNo',
                key: 'orderNo',
            },
            {
                title: '订单状态',
                dataIndex: 'orderStatusName',
                key: 'orderStatusName',
            },
            {
                title: '支付状态',
                dataIndex: 'paymentStatusName',
                key: 'paymentStatusName',
            },
            {
                title: '应付金额',
                dataIndex: 'payableAmount',
                key: 'payableAmount',
            },
            {
                title: '收货人姓名',
                dataIndex: 'receiverName',
                key: 'receiverName',
            },
            {
                title: 'SKU',
                dataIndex: 'skuCode',
                key: 'skuCode',
            },
            {
                title: 'SKN',
                dataIndex: 'sknCode',
                key: 'sknCode',
            },
        ],
        tableData: [],
        loading: false,
        showUploadModal: false,
        importColumns: [
            {
                title: 'SKN编码',
                dataIndex: 'skn',
                key: 'skn',
            },
            {
                title: '失败原因',
                dataIndex: 'msg',
                key: 'msg',
            },
        ],
        importTableData: [],
        showFailPop: false,
        failNum: 0,
        successNum: 0,
        totalNum: 0,
    };
    onShowSizeChange(current, size) {
        const paginationBak = this.state.pagination;
        this.setState(
            {
                tableData: [],
                pagination: { ...paginationBak, pageSize: size, current: current, total: 0 },
            },
            () => {
                this.loadProductList();
            }
        );
    }
    onChange(page, pageSize) {
        const paginationBak = this.state.pagination;
        this.setState(
            {
                tableData: [],
                pagination: { ...paginationBak, current: page, total: 0 },
            },
            () => {
                this.loadProductList();
            }
        );
    }
    showModal() {
        let { showUploadModal } = this.state;
        this.setState({
            showUploadModal: !showUploadModal,
        });
    }
    closeFailPop() {
        let { showFailPop } = this.state;
        this.setState({
            showFailPop: !showFailPop,
        });
    }
    downloadMould() {
        services.api
            .download(
                {},
                {
                    apiPath: `/templates/IMPORT_PRE_ORDER_SKN`,
                }
            )
            .then((res: any) => {})
            .catch((e: any) => {
                errorHandle(e);
            });
    }
    loadProductList() {
        let { pagination } = this.state;
        let { receiver_name, order_no } = this.props.form.getFieldsValue();
        this.setState({
            loading: true,
        });
        services.api
            .get(
                {
                    receiver_name,
                    order_no,
                    start_index: pagination.current,
                    page_size: pagination.pageSize,
                },
                {
                    apiPath: `/preOrder/page`,
                }
            )
            .then((res: any) => {
                const result = (res && res.result) || [];
                this.setState({
                    tableData: result,
                    loading: false,
                    pagination: { ...this.state.pagination, total: res.totalNum },
                });
            })
            .catch((e: any) => {
                errorHandle(e);
            });
    }
    toggleUploadModalFun = (data) => {
        console.log('我有值啦', data);
        if (data) {
            if (data.resultCode && data.resultCode == 200) {
                message.success('批量导入商品信息成功,稍后刷新查看', 3);
            } else {
                this.setState({
                    showFailPop: true,
                    importTableData: (data.resultBody && data.resultBody.failList) || [],
                    failNum: (data.resultBody && data.resultBody.failNum) || 0,
                    successNum: (data.resultBody && data.resultBody.successNum) || 0,
                    totalNum: (data.resultBody && data.resultBody.totalNum) || 0,
                });
                // message.error(data.resultMsg, 3);
            }
        }
        this.setState({
            showUploadModal: !this.state.showUploadModal,
        });
    };
    clear() {
        this.props.form.setFieldsValue({
            order_no: '',
            receiver_name: '',
        });
        this.setState(
            {
                order_no: '',
                receiver_name: '',
                tableData: [],
                pagination: { ...this.state.pagination, current: 1, total: 0 },
            },
            () => {
                this.loadProductList();
            }
        );
    }
    search() {
        this.setState(
            {
                tableData: [],
                pagination: { ...this.state.pagination, current: 1, total: 0 },
            },
            () => {
                this.loadProductList();
            }
        );
    }
    componentDidMount() {
        this.loadProductList();
    }
    render() {
        const {
            totalNum,
            successNum,
            failNum,
            showFailPop,
            spinning,
            showUploadModal,
            tableData,
            loading,
            columns,
            pagination,
            importColumns,
            importTableData,
        } = this.state;
        let uploadPropsObj = {
            showUploadModal: showUploadModal,
            toggleUploadModal: this.toggleUploadModalFun.bind(this),
            type: 'presellOrder',
        };
        const {
            form: { getFieldDecorator },
        } = this.props;
        return (
            <Fragment>
                <Spin spinning={spinning}>
                    <Form ref="form">
                        <Form.Item style={{ display: 'inline-block' }}>
                            {getFieldDecorator('receiver_name')(
                                <Input
                                    style={{
                                        width: 150,
                                        marginBottom: '10px',
                                        marginRight: '10px',
                                    }}
                                    placeholder="请输入收货人姓名"
                                />
                            )}
                        </Form.Item>
                        <Form.Item style={{ display: 'inline-block' }}>
                            {getFieldDecorator('order_no')(
                                <Input
                                    name="order_no"
                                    style={{
                                        width: 180,
                                        marginBottom: '10px',
                                        marginRight: '10px',
                                    }}
                                    placeholder="请输入订单编号"
                                />
                            )}
                        </Form.Item>
                        <AntButton
                            style={{ marginLeft: 16 }}
                            type="primary"
                            onClick={this.search}
                            icon="search"
                        >
                            查询
                        </AntButton>
                        <AntButton
                            style={{ marginLeft: 16 }}
                            type="primary"
                            onClick={this.clear}
                            icon="reload"
                        >
                            重置
                        </AntButton>
                    </Form>
                    <p style={{ textAlign: 'right' }}>
                        <AntButton
                            style={{ marginLeft: 16 }}
                            type="primary"
                            onClick={this.showModal}
                        >
                            批量导入
                        </AntButton>
                        <AntButton
                            style={{ marginLeft: 16 }}
                            type="default"
                            onClick={this.downloadMould}
                        >
                            下载模板
                        </AntButton>
                    </p>
                    <Table
                        rowKey="orderNo"
                        loading={loading}
                        pagination={pagination}
                        columns={columns}
                        dataSource={tableData}
                    />
                </Spin>
                {showUploadModal && <ShowProductsUploadButton {...uploadPropsObj} />}

                <Modal
                    visible={showFailPop}
                    destroyOnClose={true}
                    maskClosable={false}
                    centered
                    title="错误信息"
                    onOk={this.closeFailPop}
                    onCancel={this.closeFailPop}
                >
                    <p style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>
                            总条数：<b>{totalNum}</b>
                        </span>
                        <span>
                            正常条数：<b style={{ color: 'green' }}>{successNum}</b>
                        </span>
                        <span>
                            异常条数：<b style={{ color: 'red' }}>{failNum}</b>
                        </span>
                    </p>
                    <p style={{ color: 'red' }}>skn校验错误信息如下，请修正后重新上传！</p>
                    <div style={{ maxHeight: '300px', overflowY: 'scroll' }}>
                        <Table
                            rowKey="skn"
                            columns={importColumns}
                            dataSource={importTableData}
                            pagination={false}
                        />
                    </div>
                </Modal>
            </Fragment>
        );
    }
}
export const PrecellOrder = Form.create<PrecellOrderProps>()(precellOrder);
